import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { API_ENDPOINT } from '~/constants';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypePostShippingLabelsParams, TypePostShippingLabelsResponse } from '~/types/delivery-agency.types';

/**
 * [운송장 관리] 운송장 생성 API
 */
const fetchPostShippingLabels = async (
  params: TypePostShippingLabelsParams
): Promise<TypePostShippingLabelsResponse['data']> => {
  const { data } = await axiosInstance.post<TypePostShippingLabelsResponse>(
    API_ENDPOINT.DELIVERY_AGENCY.POST_SHIPPING_LABELS_CREATE,
    params
  );
  return data.data;
};

/**
 * [운송장 관리] 운송장 생성 Mutation Hook
 */
export const usePostShippingLabelsMutation = () => {
  return useMutation<
    TypePostShippingLabelsResponse['data'],
    TypeErrorResponseData['error'],
    TypePostShippingLabelsParams
  >({
    mutationFn: fetchPostShippingLabels,
    meta: { silent: true },
  });
};
